import React from 'react';
import styles from './HowItWorks.module.css';

const ScaleCounter = () => <div className={styles.container}>
  <div className={styles.content}>
    <div>
      <h2 className={styles.header}>It's really simple</h2>
      <span className={styles.subtitle}> - launch in seconds</span>
    </div>
    <div className={styles.steps}>
      <div className="opacity-8 flex">
        <img src="/assets/icons/one.png" height={40} className="me-3"/><div>Drag & drop your individual file or zip file
        containing your content.</div>
      </div>
{/*
      <div>[PDF, HTML, ZIP]</div>
*/}
      <div className="opacity-8 flex">
        <img src="/assets/icons/two.png" height={40} className="me-3"/> Enter a link-name or just click upload
      </div>
      <div className="opacity-8 flex">
        <img src="/assets/icons/three.png" height={40} className="me-3"/> Copy & share your link - that's it!
      </div>
    </div>
    <a href="#home">
      <button
        className="button bg-purple-light white font-18"
        style={{width: 140}}
      >
        Try it out →
      </button>
    </a>
  </div>
  <img className="d-none d-md-block" src="assets/img/demo.gif" height={400}/>
</div>

export default ScaleCounter;
